/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const SendCustomerOfferRequest = zod.object({
  confirmationToken: zod
    .string()
    .min(1)
    .describe(
      "Opaque server confirmation from prepareCustomerOfferSend. Bound to actor, Offer, current commercial view and mutation\/stage identity; not a permission grant or a client-created hidden-price digest.",
    ),
});

export type SendCustomerOfferRequest = zod.input<typeof SendCustomerOfferRequest>;
export type SendCustomerOfferRequestOutput = zod.output<typeof SendCustomerOfferRequest>;
